import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from '@edx/frontend-platform/i18n';
import { Button, Icon } from '@openedx/paragon';
import { ContentCopy, Check } from '@openedx/paragon/icons';

import { copyToClipboard } from '../../utils';
import messages from './CopyContentBlock.messages';

const CopyContentBlock = ({
  intl, label, value, headingId,
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    if (!value) { return; }
    if (copyToClipboard(value)) {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const ariaLabel = copied
    ? intl.formatMessage(messages['profile.copy-content-block.copied.aria-label'])
    : intl.formatMessage(messages['profile.copy-content-block.copy.aria-label']);

  const buttonText = copied
    ? intl.formatMessage(messages['profile.copy-content-block.copied'])
    : intl.formatMessage(messages['profile.copy-content-block.copy']);

  return (
    <div className="editable-item-header copy-content-block mb-2">
      <h2 className="edit-section-header copy-section-header" id={headingId}>
        {label}
      </h2>
      <div className="d-flex justify-content-between align-items-center">
        <p className="h5 text-gray-800 mb-0 text-break">
          {value || '—'}
        </p>

        {value && (
          <Button
            className="float-right px-0 assessment-copy"
            variant="link"
            size="sm"
            onClick={handleCopy}
            type="button"
            aria-label={ariaLabel}
          >
            <Icon
              src={copied ? Check : ContentCopy}
              className="text-primary"
            />
            {buttonText}
          </Button>
        )}
      </div>
    </div>
  );
};

CopyContentBlock.propTypes = {
  intl: intlShape.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  headingId: PropTypes.string,
};

CopyContentBlock.defaultProps = {
  headingId: null,
};

export default injectIntl(CopyContentBlock);
